import {memo} from 'react'

import {Typography, TypographyProps} from '../typography'

type MobileDrawerHeaderProps = Omit<TypographyProps, 'variant' | 'key'> & {
  title: string
}
export const DrawerHeader = memo(function DrawerHeader({title, ...typographyProps}: MobileDrawerHeaderProps) {
  return (
    <Typography mb="m" mt="xs" thickness="bold" variant="title4" {...typographyProps}>
      {title}
    </Typography>
  )
})
